import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#4EBC73\" d=\"M6 3.006C6 2.45 6.448 2 7 2s1 .45 1 1.006V20a1 1 0 1 1-2 0z\"></path><path fill=\"url(#a)\" d=\"M6 4v12h12.498a1.5 1.5 0 0 0 1.31-2.23l-2.1-3.77 2.102-3.77A1.5 1.5 0 0 0 18.498 4z\"></path><defs><linearGradient id=\"a\" x1=\"11.422\" x2=\"20.547\" y1=\"22\" y2=\"20.211\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#4EBC73\"></stop><stop offset=\"1\" stop-color=\"#4EBC73\" stop-opacity=\".3\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }